/**
 * MasonryGrid - Layout tipo Pinterest/Behance
 * Usa CSS columns para layout masonry perfecto
 * Responsive: 1 col (mobile) → 4 cols (desktop)
 */
const MasonryGrid = ({ children, className = '' }) => {
  return (
    <div className={`masonry-grid ${className}`}>
      {children}
    </div>
  );
};

export default MasonryGrid;
